import superagent from 'superagent';
import {API_URL} from "./base";

let _token;

function getAuthorizationHeader() {
    return `Token token=${_token}`;
}

export default class CouponsAPI {

    static SetUserAuthToken(token) {
        _token = token;
    }

    static CheckCoupon(code, amount, storeId, startTime) {
        const URL = `${API_URL}/coupons/check`;

        return new Promise((resolve, reject) => {

            superagent.get(URL)
                .set('Accept', 'application/json')
                .set('Authorization', getAuthorizationHeader())
                .query({code: code, amount: amount, store_id: storeId, start_time: startTime})
                .end((error, res) => {
                    error ? reject(error, res) : resolve(res.body.result);
                });
        });
    }
}